import { pick } from 'lodash';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { graphql, createFragmentContainer } from 'react-relay';
import Phone from 'react-phone-number-input';

import { updateMall } from '../../mutations';
import {
  StoreProvider,
  Label,
  ErrorFlash,
  ImageUploader,
} from '../../components';

export class MallEditView extends Component {
  constructor(props) {
    super(props);

    const mall = props.mall || {};

    this.state = {
      name: mall.name,
      phoneNumber: mall.phoneNumber,
      email: mall.email,
      pdfMapUrl: mall.pdfMapUrl,
      address: mall.address,
      errors: null,
      smallMap: null,
      largeMap: null,
      smallMapUrl: mall.smallMapUrl,
      largeMapUrl: mall.largeMapUrl,
      mondayOpening: mall.mondayOpening,
      mondayClosing: mall.mondayClosing,
      tuesdayOpening: mall.tuesdayOpening,
      tuesdayClosing: mall.tuesdayClosing,
      wednesdayOpening: mall.wednesdayOpening,
      wednesdayClosing: mall.wednesdayClosing,
      thursdayOpening: mall.thursdayOpening,
      thursdayClosing: mall.thursdayClosing,
      fridayOpening: mall.fridayOpening,
      fridayClosing: mall.fridayClosing,
      saturdayOpening: mall.saturdayOpening,
      saturdayClosing: mall.saturdayClosing,
      sundayOpening: mall.sundayOpening,
      sundayClosing: mall.sundayClosing,
    };
  }

  // update events
  handleUpdateName = (event) => {
    this.setState({ name: event.target.value });
  };

  handleUpdatePhoneNumber = (phone) => {
    this.setState({ phoneNumber: phone.replace('+1', '') });
  };

  handleUpdateEmail = (event) => {
    this.setState({ email: event.target.value });
  };

  handleUpdatepdfMapUrl = (event) => {
    this.setState({ pdfMapUrl: event.target.value });
  };

  handleUpdateAddress = (event) => {
    this.setState({ address: event.target.value });
  };

  handleUpdateHour = (event) => {
    this.setState({ [event.target.id]: parseInt(event.target.value) });
  }

  // submission
  handleSubmit = (event) => {
    event.preventDefault();

    const { relay } = this.props;
    const attributes = pick(this.state, [
      'name',
      'phoneNumber',
      'email',
      'pdfMapUrl',
      'address',
      'smallMap',
      'largeMap',
      'mondayOpening',
      'mondayClosing',
      'tuesdayOpening',
      'tuesdayClosing',
      'wednesdayOpening',
      'wednesdayClosing',
      'thursdayOpening',
      'thursdayClosing',
      'fridayOpening',
      'fridayClosing',
      'saturdayOpening',
      'saturdayClosing',
      'sundayOpening',
      'sundayClosing',
    ]);

    updateMall(relay.environment, attributes, {
      onCompleted: this.handleSubmitSuccess,
    });
  };

  handleSubmitSuccess = (response) => {
    let { errors } = response.updateMall;
    if (errors) {
      this.setState({ errors: errors });
    } else {
      this.props.history.push('/mall-info');
    }
  };

  handleSubmitFailure = (err) => {
    console.error(err.message);
  };

  handleSmallMapUploaded = (smallMap) => {
    this.setState({ smallMap });
  };

  handleLargeMapUploaded = (largeMap) => {
    this.setState({ largeMap });
  };

  render() {
    let { errors } = this.state;

    return (
      <div className="mall-edit">
        <form className="mall-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Edit Mall Info</h2>
            <div className="form-header-actions">
              <Link to="/mall-info">Cancel</Link>
              <input
                id="saveMall"
                className="mall-submit"
                type="submit"
                defaultValue="Save"
              />
            </div>
          </div>

          <div className="form-fields">
            <ErrorFlash errors={errors} />

            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <div className="input">
                    <Label attr="name" text="Name" errors={errors} />
                    <input
                      type="text"
                      id="name"
                      value={this.state.name}
                      onChange={this.handleUpdateName}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label attr="address" text="Location" errors={errors} />
                    <textarea
                      id="address"
                      value={this.state.address}
                      onChange={this.handleUpdateAddress}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label
                      attr="phoneNumber"
                      text="Phone Number"
                      errors={errors}
                    />
                    <Phone
                      id="phoneNumber"
                      countries={['US']}
                      value={this.state.phoneNumber}
                      onChange={this.handleUpdatePhoneNumber}
                    />
                  </div>

                  <div className="input">
                    <Label attr="email" text="Email" errors={errors} />
                    <input
                      type="text"
                      id="email"
                      value={this.state.email}
                      onChange={this.handleUpdateEmail}
                      required
                    />
                  </div>

                  <div className="input">
                    <Label
                      attr="pdfMapUrl"
                      text="PDF map url"
                      errors={errors}
                    />
                    <input
                      type="text"
                      id="pdfMapUrl"
                      value={this.state.pdfMapUrl}
                      onChange={this.handleUpdatepdfMapUrl}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <h3>Hours</h3>
                <div className="form-group-fields">
                  <div className="form-group-column">

                    <div className="input">
                      <Label
                        attr="mondayHours"
                        text="Monday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="mondayOpening"
                          value={this.state.mondayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="mondayClosing"
                          value={this.state.mondayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="tuesdayHours"
                        text="Tuesday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="tuesdayOpening"
                          value={this.state.tuesdayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="tuesdayClosing"
                          value={this.state.tuesdayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="wednesdayHours"
                        text="Wednesday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="wednesdayOpening"
                          value={this.state.wednesdayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="wednesdayClosing"
                          value={this.state.wednesdayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="thursdayHours"
                        text="Thursday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="thursdayOpening"
                          value={this.state.thursdayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="thursdayClosing"
                          value={this.state.thursdayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="fridayHours"
                        text="Friday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="fridayOpening"
                          value={this.state.fridayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="fridayClosing"
                          value={this.state.fridayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="saturdayHours"
                        text="Saturday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="saturdayOpening"
                          value={this.state.saturdayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="saturdayClosing"
                          value={this.state.saturdayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                    <div className="input">
                      <Label
                        attr="sundayHours"
                        text="Sunday Hours"
                        errors={errors}
                      />
                      <div className="hours-input">
                        <input
                          type="number"
                          id="sundayOpening"
                          value={this.state.sundayOpening}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00 to</span>
                        <input
                          type="number"
                          id="sundayClosing"
                          value={this.state.sundayClosing}
                          onChange={this.handleUpdateHour}
                          min="1"
                          max="23"
                          required
                        />
                        <span>:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <h3>Maps</h3>

                <div className="form-group-fields">
                  <div className="form-group-column">
                    <div className="input image-upload">
                      <Label attr="smallMap" text="Small Map" errors={errors} />
                      <div className="image-upload-hint">
                        Image should be a .png or .jpg and have dimensions of
                        375w x 203h
                      </div>
                      <ImageUploader
                        cover
                        onUploaded={this.handleSmallMapUploaded}
                        type="mall"
                        source={this.state.smallMapUrl}
                      />
                    </div>
                  </div>
                  <div className="form-group-column">
                    <div className="input image-upload">
                      <Label attr="smallMap" text="Large Map" errors={errors} />
                      <div className="image-upload-hint">
                        Image should be a .png or .jpg and have an aspect ratio
                        of 375w x 203h. It can be fairly large, but images that
                        are too large will take longer to load on the mobile
                        app.
                      </div>
                      <ImageUploader
                        cover
                        onUploaded={this.handleLargeMapUploaded}
                        type="mall"
                        source={this.state.largeMapUrl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = withRouter(
  createFragmentContainer(MallEditView, {
    mall: graphql`
      fragment MallEdit_mall on Mall {
        name
        phoneNumber
        email
        pdfMapUrl
        address
        smallMapUrl
        largeMapUrl
        mondayOpening
        mondayClosing
        tuesdayOpening
        tuesdayClosing
        wednesdayOpening
        wednesdayClosing
        thursdayOpening
        thursdayClosing
        fridayOpening
        fridayClosing
        saturdayOpening
        saturdayClosing
        sundayOpening
        sundayClosing
      }
    `,
  })
);

export default class MallEdit extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query MallEditQuery {
            mall {
              ...MallEdit_mall
            }
          }
        `}
      />
    );
  }
}
